import { useTranslation } from 'react-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Layout from '../components/Layout';
import Meta from '../components/Meta';
import Breadcrumb from '../components/Breadcrumb';
import Container from '../components/Container';

const PagePrivacyPolicy = () => {
  const { t } = useTranslation(['common', 'privacy-policy']);

  return (
    <Layout className="page-privacy-policy">
      <Meta
        title={t('privacy-policy:meta.title')}
        description={t('privacy-policy:meta.description')}
      />
      <Container narrow>
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            {t('common:nav.index')}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {t('common:nav.privacy-policy')}
          </Breadcrumb.Item>
        </Breadcrumb>
        <article className="content">
          <h1>
          {t('privacy-policy:intro.title')}
          </h1>
          <h3>
            General provisions
          </h3>
          <p>
            This Privacy Policy governs the collection, use and storage of information (hereinafter: Information) and any data (hereinafter: Data) obtained through your use of our PDF Tools website available at pdf.tools.com. We do not sell, rent or otherwise make available Information or Data to third-parties. We use collected Information and Data for our internal purposes and as necessary by the nature of the Services. In some instances, we are obliged to comply with court orders and government requests and provide Information or parts of it to authorized bodies. We may disclose or access Information whenever we believe in good faith that the law so requires, such as to comply with a litigation, or that disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or if we otherwise consider it necessary to do so to maintain service and improve our products and services. The Information on users is divided into personally identifiable and non-personally identifiable Information depending on whether Information can identify the user as a specific person.
          </p>
          <h3>
            Changes to the Privacy Policy
          </h3>
          <p>
            We reserve the right to change our Privacy Policy at any time without prior notification. The current version of Privacy Policy is available on the Site, indicating the effective date. You are encouraged to periodically check our Privacy Policy.
          </p>
          <h3>
            Consent
          </h3>
          <p>
            By accessing the Sites you agree to have your Information and Data handled as described in this Privacy Policy. The services are intended for a general audience and are not targeted at children.
          </p>
          <h3>
            Personally identifiable information
          </h3>
          <p>
            No registration is necessary for the use of our Services. We do not collect any personally identifiable information, your IP address, or any other Information which either alone or in connection with other data can be used to identify you.
          </p>
          <p>
            If you send an e-mail to our e-mail address indicated on the Sites, we may keep records of such communication and any question, complaint or compliment made by you and the response if any. Whenever you contact us, we will only use your e-mail address in order to provide the response, if any. We do not store your e-mail address nor use it for any other purpose.
          </p>
          <p>
            We endeavor to maintain appropriate physical, procedural and technical security with respect to the collected information so as to prevent any loss, misuse, unauthorized access, disclosure, or modification of personal information which also applies to our disposal or destruction of personal information. Our Sites uses SSL encryption in order to provide additional security of your information.
          </p>
          <h3>
            Non-personally identifiable information and data
          </h3>
          <p>
            During your use of our Service, you may provide us with Non-Personally Identifiable Information and Data as necessary by the nature of the Service. You can either upload Data on your own or use Cloud Providers (Google Drive or Dropbox) to upload your Data from cloud storage.
          </p>
          <p>
            We use such Information and Data only for the purpose of providing you with the Service requested and to improve the user experience. We do not monitor or access the Data provided by you. Processing of the Information and Data is completely automated without any human interaction or supervision.
          </p>
          <p>
            If you choose to upload your Data through the Cloud Providers, you are giving us permission to access and to view, download and interact with such Data. We are only interacting with the Data in a way that is strictly necessary by the nature of the requested Service. We do not access, collect, use or store any Data or Information that is not necessary to provide you with the Service requested.
          </p>
          <p>
            Any Data which you provide for the purpose of utilizing our Services is stored on our servers only for as long as necessary, and is deleted automatically no later than twelve (12) hours from the moment you complete your use of our Services.
          </p>
          <h3>
            Cookies
          </h3>
          <p>
            Cookies help us optimize and improve the user experience of the Sites by helping us deliver crucial functionalities. The cookies we use may vary over time as we continuously update and improve our Sites.
          </p>
          <p>
            Third party applications that we use, such as Dropbox, Google Drive, Google Analytics, Google DoubleClick, and Google Adsense do use cookies on our site to help analyse the web traffic or determine targeted advertisements based on your preferences. To opt out of Google’s use of cookies, please visit the Google ad and content network privacy policy. If you prefer not to use cookies at all, we recommend adjusting your browser settings accordingly. If you are unsure how to do that, use your favorite search engine to find out everything about it or visit cookiesandyou.com.
          </p>
        </article>
      </Container>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, [
      'common',
      'privacy-policy',
    ]),
  },
});

export default PagePrivacyPolicy;
